// extracted by mini-css-extract-plugin
module.exports = {"alert":"InlineAlert_alert__NxmZP","icon":"InlineAlert_icon__2tReX","message":"InlineAlert_message__2HZ9_","actions":"InlineAlert_actions__1ruID"};